/**
 * Headers for calling our own /api endpoints as the signed-in coach.
 *
 * Endpoints check who is calling on the server (api/_auth.js), from the
 * session's access token, rather than trusting the browser. No session, no
 * Authorization header: the endpoint then answers 401.
 */
import { accessToken } from "../supabaseClient";

export async function authHeaders(extra = {}) {
  try {
    const token = await accessToken();
    return token ? { ...extra, Authorization: `Bearer ${token}` } : { ...extra };
  } catch {
    return { ...extra };
  }
}
